import { render, staticRenderFns } from "./FrappeGantt.vue?vue&type=template&id=e830565e&"
import script from "./FrappeGantt.vue?vue&type=script&lang=js&"
export * from "./FrappeGantt.vue?vue&type=script&lang=js&"
import style0 from "./FrappeGantt.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports